"use client"

import { useMemo } from "react"

import { useScroll } from "../../index"

/**
 * Header 滚动状态 Hook
 * 根据透明模式和滚动状态计算 Header 的样式状态
 */
export function useHeaderScrollState(transparentMode: boolean): "scrolled" | "transparent" {
  const { isScrolled } = useScroll()

  // 在水合完成前，使用默认的 transparent 状态避免闪烁
  const scrollState = useMemo(() => {
    if (!transparentMode) {
      return "scrolled"
    }
    return isScrolled ? "scrolled" : "transparent"
  }, [isScrolled, transparentMode])

  return scrollState
}
